import { render } from "./App.vue?vue&type=template&id=2b4de31a&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=2b4de31a&lang=scss"

import exportComponent from "D:\\projects\\tmp\\ball-falling-steps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__